import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

const { SWIVU_SENTRY_KEY } = import.meta.env;

// for now we don't have any other method to check for if it's a localhost
if (SWIVU_SENTRY_KEY) {
  console.log("Enabling LogRocket Analytics...");

  LogRocket.init('3wnapj/swivu');

  setupLogRocketReact(LogRocket);

}

export const addUserIdentifyToLogRocket = (user) => {
  LogRocket.identify(user.id, {
    name: `${user.first_name} ${user.last_name}`,
    email: user.email,
    token: user.token
  });
}
